// extracted by mini-css-extract-plugin
export var brand = "_7m-9";
export var compact = "_7m-6";
export var extraSmall = "_7m-7";
export var icon = "_7m-0";
export var large = "_7m-4";
export var light = "_7m-1";
export var medium = "_7m-5";
export var outline = "_7m-b";
export var primaryDark = "_7m-a";
export var primaryLight = "_7m-8";
export var primaryModern = "_7m-c";
export var success = "_7m-2";
export var successSolid = "_7m-3";